import client from './AxiosClient'

const userService = {
    login : (data) => client.post("/auth/login",data),
    filter : (params) => client.get("/users/filter", { params }),
    getAvailableValidator : (params) => client.get("/users/available-validator",{params}),
    create : (data) => client.post("/users", data),
    updateStatus : (userId) => client.patch(`admin/toggle-active/${userId}`),
    changePassword : (data) => client.put(`/admin/change-password`, data),

    getOne : (userId) => client.get(`/users?id=${userId}`),
    generateKYCLink : (userId) => client.get(`/admin/generate-link?userId=${userId}`),
    sendKYCLinkOnMail : (data) => client.post("/admin/kyc-mail", data),
    sendKYCLinkOnPhone : (userId) => client.post(`/admin/kyc-phone/${userId}`),

    stats : () => client.get(`/admin/dashboard`),
}


export default userService;